/** @jsx jsx */
import React, { ReactNode } from 'react';
import { jsx } from '@balance-web/core';
import { useRawTheme } from '@balance-web/theme';
import { Flex } from '@balance-web/flex';
import { Text } from '@balance-web/text';
import { hexToRgb } from '@balance-web/utils';

export type SingleSignOnButtonProps = {
  label: string;
  onClick: () => void;
  icon: ReactNode;
};

export const SingleSignOnButton = ({
  label,
  icon,
  onClick,
}: SingleSignOnButtonProps) => {
  const { palette } = useRawTheme();
  return (
    <Flex
      as="button"
      onClick={onClick}
      // styles
      alignItems="center"
      background="base"
      border="muted"
      borderRadius="medium"
      gap="small"
      justifyContent="center"
      padding="medium"
      width="100%"
      css={{
        '&:hover': {
          background: hexToRgb(palette.button.passive.background, 0.2),
        },
        '&:active': {
          background: hexToRgb(palette.button.passive.background, 0.3),
        },
      }}
    >
      {icon}
      <Text weight="medium">{label}</Text>
    </Flex>
  );
};
